import Image from "next/image";
import React from "react";
import { useIsSSR } from "react-aria";
import { Item as PhotoswipeGalleryItem } from "react-photoswipe-gallery";
import styled from "styled-components";
import { Picture } from "~/components/PictureGallery/Picture";

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  scroll-snap-align: start;
  cursor: pointer;
`;

const GalleryPicture = ({ picture }: { picture: Picture }) => {
  const isSSR = useIsSSR();

  if (isSSR) {
    return (
      <Image
        fill
        src={picture.src}
        alt={picture.alt}
        style={{ objectFit: "cover" }}
      />
    );
  }

  return (
    <PhotoswipeGalleryItem
      original={picture.src}
      width={picture.width}
      height={picture.height}
      alt={picture.alt}
      cropped
    >
      {({ open, ref }) => (
        <ImageContainer ref={ref as any}>
          <Image
            fill
            src={picture.src}
            alt={picture.alt}
            style={{ objectFit: "cover" }}
            onClick={open}
          />
        </ImageContainer>
      )}
    </PhotoswipeGalleryItem>
  );
};

export default GalleryPicture;
